import { useParams } from 'react-router-dom'
import { type Locale } from '@/env'
import { DEFAULT_LOCALE, SUPPORTED_LOCALES } from '@/env'

/** Reads the active locale from the route's :locale segment, falling back to es. */
export function useLocale(): Locale {
  const { locale } = useParams<{ locale: string }>()
  if (locale && SUPPORTED_LOCALES.includes(locale as Locale)) return locale as Locale
  return DEFAULT_LOCALE
}